export default __webpack_public_path__ + "static/media/google.faf01ea1.svg";